var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#E3E3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.222 26.792l-4.667-4.667 4.667-4.667a1.1 1.1 0 10-1.555-1.556L22 20.57l-4.667-4.667a1.1 1.1 0 10-1.556 1.556l4.667 4.667-4.667 4.667a1.1 1.1 0 101.556 1.555L22 23.68l4.667 4.667a1.1 1.1 0 101.555-1.555z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.6
  })));
}

export default SvgCloseGrey;